import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login.component';
import { ShellComponent } from './layout/shell/shell.component';
import { authGuard } from './core/guards/auth.guard';
import { ResetPwdComponent } from './features/reset-pwd/reset-pwd.component';
import { NewPwdComponent } from './features/new-pwd/new-pwd.component';

export const routes: Routes = [
  // PUBBLICA (senza Shell)
  { path: 'login', component: LoginComponent },
  { path: 'reset-pwd', component: ResetPwdComponent },
  { path: 'reset-password', pathMatch: 'full', component: NewPwdComponent },
  // PROTETTE (con Shell)
  {
    path: '',
    component: ShellComponent,
    canActivateChild: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent) },

      // Preventivi + dettaglio
      { path: 'preventivi', loadComponent: () => import('./features/preventivi/preventivi.component').then(m => m.PreventiviComponent) },
      { path: 'preventivi/:id', loadComponent: () => import('./features/preventivi/components/dettaglio/preventivo-dettaglio.component').then(m => m.PreventivoDettaglioComponent) },

      // cantieri + dettaglio
      { path: 'cantieri', loadComponent: () => import('./features/cantieri/cantieri.component').then(m => m.CantieriComponent) },
      { path: 'cantieri/:id', loadComponent: () => import('./features/cantieri/components/dettaglio/cantiere-dettaglio.component').then(m => m.CantiereDettaglioComponent) },

      // Fatture + dettaglio
      { path: 'fatture', loadComponent: () => import('./features/fatture/fatture.component').then(m => m.FattureComponent) },
      { path: 'fatture/:id', loadComponent: () => import('./features/fatture/components/dettaglio/fattura-dettaglio.component').then(m => m.FatturaDettaglioComponent) },

      // Attrezzatura + dettaglio
      {
        path: 'attrezzature',
        loadComponent: () =>
          import('./features/attrezzature/attrezzature.component').then(m => m.AttrezzatureComponent),
      },
      { path: 'attrezzature/:id', loadComponent: () => import('./features/attrezzature/components/dettaglio/dettaglio-attrezzatura.component').then(m => m.DettaglioAttrezzaturaComponent) },


      { path: 'garage', loadComponent: () => import('./features/garage/garage.component').then(m => m.GarageComponent) },
      { path: 'garage/:id', loadComponent: () => import('./features/garage/components/dettaglio/dettaglio-mezzo.component').then(m => m.DettaglioMezzoComponent) },

      // Fornitori e Clienti
      {
        path: 'anagrafiche',
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'clienti' },
          {
            path: 'fornitori',
            loadComponent: () =>
              import('./features/anagrafiche/anagrafiche.component')
                .then(m => m.AnagraficheComponent),
          },
          {
            path: 'fornitori/:id',
            loadComponent: () =>
              import('./features/anagrafiche/components/dettaglio/dettaglio-attore.component')
                .then(m => m.DettaglioAttoreComponent),
          },
          {
            path: 'clienti',
            loadComponent: () =>
              import('./features/anagrafiche/anagrafiche.component')
                .then(m => m.AnagraficheComponent),
          },
          {
            path: 'clienti/:id',
            loadComponent: () =>
              import('./features/anagrafiche/components/dettaglio/dettaglio-attore.component')
                .then(m => m.DettaglioAttoreComponent),
          },
        ],
      },
      { path: 'impostazioni', loadComponent: () => import('./features/settings/settings.component').then(m => m.SettingsComponent) },
      { path: 'costi-fissi', loadComponent: () => import('./features/costi-fissi/costi-fissi.component').then(m => m.CostiFissiComponent) },
    ],
  },

  // Fallback
  { path: '**', redirectTo: '' },
];
